// extracted by mini-css-extract-plugin
export var dropzoneWrapper = "_80d24a7322543a52a98fbb1ee7ab7626-css";